
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button, Divider, Form, Modal } from "semantic-ui-react";
import { Link } from "react-router-dom";

//Actions 
import { initialStateGeneralRate } from "../../redux/actions/rates/generalRates/fetchGeneralRate";
import { initialStateIkarusRate } from "../../redux/actions/rates/ikarusRates/fetchIkarusRate";

export default function DeleteRateModal(props) {
  const { t } = useTranslation();
  const [open, setOpen] = React.useState(false)
  const dispatch = useDispatch();

  const closeModal = () => {
    setOpen(false)
    if(props.typeRate ==="GeneralRate") {
      dispatch(initialStateGeneralRate());
    } else if(props.typeRate ==="IkarusRate") {
      dispatch(initialStateIkarusRate());
    } 
  }

  return (
    <>
      <Modal
        onClose={() => setOpen(false)}
        onOpen={() => setOpen(true)}
        open={open}
        trigger={<Button circular color='red' icon='trash alternate' />}
        size="tiny"
      >
        <Modal.Header>
          {t("general_delete")}
        </Modal.Header>
        {props.stateError === "exits cabins in rate" ?
          <Modal.Content>
            <Modal.Description>
              <Form.Group widths="equal">
                <Form.Field>
                  <div className="bg-red-300 p-2 border border-red-500 rounded-md">
                    <label>{t(props.stateError)}</label>
                  </div>
                </Form.Field>
              </Form.Group>
            </Modal.Description>
          </Modal.Content> : " "
        }
        <Modal.Actions>
          <Button onClick={() => closeModal()}>
            {t("canceled_button")}
          </Button>
          {props.stateError === "exits cabins in rate" ?
            <Link to={`/generalRates/${props.stateRate.id}/cabins`}>
              <Button color='red'>{t("delete_button_cabins")}</Button>
            </Link> :
            <Button onClick={props.handleDelete} color="red">
              {t("delete_button")}
            </Button>
          }
        </Modal.Actions>
      </Modal>
    </>
  );
}
